import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentData, Query } from '@angular/fire/firestore';
import firebase from 'firebase/app';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
@Injectable()
export class TutorService {

  private idTutor = new Subject<string>();

  private headerObservable = new Subject<any>();

  currentIdTutor$ = this.idTutor.asObservable();

  constructor(private firestore: AngularFirestore) { }

  changeIdTutor(id: string): void {
    this.idTutor.next(id);
  }
  public getUser(id): any {
    return this.firestore.collection('users').doc(id).valueChanges({ idField: 'id' });
  }
  public getUsers(dni): Query<DocumentData>{
    return firebase.firestore().collection('users').where('numberDNI', '==', dni);
  }

  public updateUserLastInscriptionId(id, lastInscriptionIdParam): any {
    return this.firestore.collection('users').doc(id).update({
      lastInscriptionId : lastInscriptionIdParam
    });
  }

  public updateUserStatus(id, status2): any {
    return this.firestore.collection('users').doc(id).update({
      status: status2
    });
  }

  public updateUserStatusFinishInscription(alumno, status2): any {
    return this.firestore.collection('users').doc(alumno.id).update({
      status: status2,
      isNewInscription : false,
      statusCourses: firebase.firestore.FieldValue.arrayRemove(alumno.lastStatusCourses),
      idLastCourse :  firebase.firestore.FieldValue.delete(),
      lastInscriptionId : firebase.firestore.FieldValue.delete()
    });
  }
  public setLastStatusCourse(alumno): any{
    return this.firestore.collection('users').doc(alumno.id).update({
      statusCourses: firebase.firestore.FieldValue.arrayUnion(alumno.lastStatusCourses)
    });
  }

  public updateUserSendEmail(id): any {
    return this.firestore.collection('users').doc(id).update({
      emailSend: 'enviado',
      didTest : true
    });
  }

  public suscribeHeader(): Observable<any> {
    return this.headerObservable.asObservable();
  }

  public getHeaderObservable(): Subject<any> {
    return this.headerObservable;
  }

  public updateUserRegistrationDate(id, date): any {
    return this.firestore.collection('users').doc(id).update({
      registrationDate: date,
    });
  }
  public updateUserCourseSelectedTime(id, date): any {
    return this.firestore.collection('users').doc(id).update({
      courseSelectedTime: date,
    });
  }

  public updateUserInfoAcademicaAlumno(alumno): any {
    return this.firestore.collection('users').doc(alumno.id).update({
      courses: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/courses/${alumno.cursoElegido.id}`)),
      status: alumno.status,
      municipality: alumno.municipio,
      centro: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/centers/${alumno.centroId}`)),
      inscripcionId: alumno?.inscripcionId || '',
      registrationDate: alumno?.cursoElegido?.registrationDate,
      billableConceptsStudent: firebase.firestore.FieldValue.arrayUnion(
        {
          accounting: alumno?.cursoElegido.accounting || '',
          billableConcepts: alumno?.cursoElegido.billableConcepts,
          center: alumno?.cursoElegido?.centerDescription,
          centerId: 'centers/' + alumno?.cursoElegido?.center?.id || '',
          codeCourse: alumno?.cursoElegido?.code || '',
          description: alumno?.cursoElegido?.description || '',
          idCourse: 'courses/' + alumno?.cursoElegido?.id || '',
          idCourseAux: alumno?.cursoElegido?.id || '',
          serie: alumno?.cursoElegido?.serieName || '',
          serieId: 'series/' + alumno?.cursoElegido?.serie?.id || '',
        }),
      statusCourses: firebase.firestore.FieldValue.arrayUnion(
        {
          idStatus: 'courses/' + alumno?.cursoElegido?.id || '',
          statusStudentCourse: alumno?.statusCourseAux,
          codeCourse: alumno?.cursoElegido?.code || '',
          inscripcionId: alumno?.inscripcionId || '',
          idCourse : alumno?.cursoElegido?.id,
          courseStatus : alumno?.statusCourseAux,
        }),
      idLastCourse: alumno?.cursoElegido.id || '',
      idLastSerie: alumno?.cursoElegido?.serie?.id || '',
      codeLastCourse: alumno?.cursoElegido?.code || '',
      idLastCenter: alumno?.cursoElegido?.center?.id || '',
      codePromocional: alumno?.code || '',
      codePromocionalId: alumno?.codeId || '',
      startDateLastCourse: alumno?.cursoElegido?.startDateCourse || '',
      endDateLastCourse: alumno?.cursoElegido?.endDate || '',
      dayLastCourse: alumno?.dia,
      starTimeLastCourse: alumno.cursoElegido.startTime,
      showStudent : alumno?.showStudent,
      lastBillableConceptsStudent : {
        accounting: alumno?.cursoElegido.accounting || '',
        billableConcepts: alumno?.cursoElegido.billableConcepts,
        center: alumno?.cursoElegido?.centerDescription,
        centerId: 'centers/' + alumno?.cursoElegido?.center?.id || '',
        codeCourse: alumno?.cursoElegido?.code || '',
        description: alumno?.cursoElegido?.description || '',
        idCourse: 'courses/' + alumno?.cursoElegido?.id || '',
        idCourseAux: alumno?.cursoElegido?.id || '',
        serie: alumno?.cursoElegido?.serieName || '',
        serieId: 'series/' + alumno?.cursoElegido?.serie?.id || '',
      },
      lastStatusCourses:  {
        idStatus: 'courses/' + alumno?.cursoElegido?.id || '',
        statusStudentCourse: alumno?.statusCourseAux,
        codeCourse: alumno?.cursoElegido?.code || '',
        inscripcionId: alumno?.inscripcionId || '',
        idCourse : alumno?.cursoElegido?.id,
        courseStatus : alumno?.statusCourseAux,
      }
    });
  }

  public eliminarUserInfoAcademicaAlumno(alumno): any {
    return this.firestore.collection('users').doc(alumno.id).update({
      courses: firebase.firestore.FieldValue.arrayRemove(firebase.firestore().doc(`/courses/${alumno.idLastCourse}`)),
      status: 'prospectivo',
      municipality: '',
      centro: firebase.firestore.FieldValue.arrayRemove(firebase.firestore().doc(`/centers/${alumno.idLastCenter}`)),
      billableConceptsStudent: firebase.firestore.FieldValue.arrayRemove(alumno.lastBillableConceptsStudent),
      courseSelectedTime: firebase.firestore.FieldValue.delete(),
      registrationDate: firebase.firestore.FieldValue.delete(),
      codePromocional: firebase.firestore.FieldValue.delete(),
      codePromocionalId: firebase.firestore.FieldValue.delete(),
      codeLastCourse: firebase.firestore.FieldValue.delete(),
      startDateLastCourse: firebase.firestore.FieldValue.delete(),
      endDateLastCourse: firebase.firestore.FieldValue.delete(),
      statusCourses: firebase.firestore.FieldValue.arrayRemove(alumno.lastStatusCourses),
      idLastCourse :  firebase.firestore.FieldValue.delete(),
      showStudent : false
    });
  }

  public eliminarUserInfoAcademicaAlumnoEspecifica(alumno): any {
    return this.firestore.collection('users').doc(alumno.id).update({
      courses: firebase.firestore.FieldValue.arrayRemove(firebase.firestore().doc(`/courses/${alumno.cursoElegido.id}`)),
      status: 'prospectivo',
      municipality: '',
      centro: firebase.firestore.FieldValue.arrayRemove(firebase.firestore().doc(`/centers/${alumno.centroId}`)),
      billableConceptsStudent: firebase.firestore.FieldValue.arrayRemove({
        accounting: alumno?.cursoElegido.accounting || '',
        billableConcepts: alumno?.cursoElegido.billableConcepts,
        center: alumno?.cursoElegido?.centerDescription,
        centerId: 'centers/' + alumno?.cursoElegido?.center?.id || '',
        codeCourse: alumno?.cursoElegido?.code || '',
        description: alumno?.cursoElegido?.description || '',
        idCourse: 'courses/' + alumno?.cursoElegido?.id || '',
        idCourseAux: alumno?.cursoElegido?.id || '',
        serie: alumno?.cursoElegido?.serieName || '',
        serieId: 'series/' + alumno?.cursoElegido?.serie?.id || '',
      }),
      courseSelectedTime: firebase.firestore.FieldValue.delete(),
      registrationDate: firebase.firestore.FieldValue.delete(),
      codePromocional: firebase.firestore.FieldValue.delete(),
      codePromocionalId: firebase.firestore.FieldValue.delete(),
      codeLastCourse: firebase.firestore.FieldValue.delete(),
      startDateLastCourse: firebase.firestore.FieldValue.delete(),
      endDateLastCourse: firebase.firestore.FieldValue.delete(),
      statusCourses: firebase.firestore.FieldValue.arrayRemove({
        idStatus: 'courses/' + alumno?.cursoElegido?.id || '',
        statusStudentCourse: alumno.status,
        codeCourse: alumno?.cursoElegido?.code || '',
        inscripcionId: alumno?.inscripcionId || '',
        idCourse : alumno?.cursoElegido?.id,
        courseStatus : alumno.status,
      }),
      idLastCourse :  firebase.firestore.FieldValue.delete(),
      showStudent : false
    });
  }
  public establecerInfoAcademicaTutor(id, codeId): any {
    return this.firestore.collection('users').doc(id).update({
      codes: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/codes/${codeId}`))
    });
  }

  public crearActualizarTerminosCondiciones(id, nombres, apellidos, consentimiento): any {
    return this.firestore.collection('users').doc(id).update({
      nombresLegales: nombres,
      apellidosLegales: apellidos,
      aceptaTerminosCondiciones: consentimiento
    });
  }

  public updateDomiciliacionBancaria(tutor): any {
    return this.firestore.collection('users').doc(tutor.id).update({
      titularPayment: tutor?.titularPayment || '',
      documentTitular: tutor?.documentTitular || '',
      numberDNITitular: tutor?.numberDNITitular || '',
      addressTitular: tutor?.addressTitular || '',
      zipTitular: tutor?.zipTitular || '',
      municipalityTitular: tutor?.municipalityTitular || '',
      cityTitular: tutor?.cityTitular || '',
      countryTitular: tutor?.countryTitular || '',
      swiftBicTitular: tutor?.swiftBicTitular || '',
      IBAN: tutor?.IBAN || '',
      paymentMethod: firebase.firestore().doc(`/payment_methods/${tutor.paymentMethod}`),
      dateTitular: tutor?.dateTitular || ''
    });
  }

  public updateUserTutorRegistro(tutor): any {
    return this.firestore.collection('users').doc(tutor.id).update({
      firstname: tutor?.firstname,
      lastname: tutor?.lastname,
      fullname: tutor?.firstname + ' ' + tutor?.lastname,
      dob: tutor?.dob,
      dobDatePicker: tutor?.dobDatePicker,
      sexo: tutor?.sexo,
      parentesco: tutor?.parentesco,
      address: tutor?.address,
      age: tutor?.age,
      number: tutor?.number,
      zip: tutor?.zip,
      municipality: tutor?.municipality,
      city: tutor?.city,
      numberDNI: tutor?.numberDNI,
      originTutor: tutor?.originTutor,
      phone1: tutor?.phone1,
      tipoVia: tutor?.tipoVia,
      medioContacto: tutor?.medioContacto,
      document: tutor?.document
    });
  }
  public updateEstudianteRegistro(alumno): any {
    return this.firestore.collection('users').doc(alumno.id).update({
      age: alumno.age,
      firstname: alumno.firstname,
      lastname: alumno?.lastname,
      fullname: alumno?.firstname + ' ' + alumno?.lastname,
      sexo: alumno?.sexo,
      dobDatePicker: alumno?.dobDatePicker,
      dob: alumno?.dob
    });
  }
  public removerEstudianteTutor(tutorId, alumnoId): any {
    return this.firestore.collection('users').doc(tutorId).update({
      alumns: firebase.firestore.FieldValue.arrayRemove(firebase.firestore().doc(`/users/${alumnoId}`))
    });
  }
  public eliminarEstudiante(alumnoId): any {
    return this.firestore.collection('users').doc(alumnoId).delete();
  }

}
